/**
 * @generated SignedSource<<f3443cafc95739f8ea2a41d98481e7ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EventUpdateInput = {
  happenedAt?: any | null | undefined;
  id: string;
};
export type EventCardUpdateMutation$variables = {
  input: EventUpdateInput;
};
export type EventCardUpdateMutation$data = {
  readonly updateEvent: {
    readonly node: {
      readonly happenedAt: any | null | undefined;
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type EventCardUpdateMutation = {
  response: EventCardUpdateMutation$data;
  variables: EventCardUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EventEdge",
    "kind": "LinkedField",
    "name": "updateEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "happenedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventCardUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventCardUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a5153752be4c2e17f8907659300c6106",
    "id": null,
    "metadata": {},
    "name": "EventCardUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation EventCardUpdateMutation(\n  $input: EventUpdateInput!\n) {\n  updateEvent(input: $input) {\n    node {\n      id\n      happenedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d3f7a3bfd82f28217eeb6508b9220a80";

export default node;
